import { gql } from "@apollo/client";

export const LIST_STAFF_EMAILS = gql`
  query listStaffEmails {
    listStaffEmails {
      fullName
      email
    }
  }
`;

export const CREATE_STAFF_EMAIL = gql`
  mutation staffEmailCreate($email: String!, $fullName: String!) {
    staffEmailCreate(email: $email, fullName: $fullName) {
      fullName
      email
    }
  }
`;

export const DELETE_STAFF_EMAIL = gql`
  mutation staffEmailDelete($email: String!) {
    staffEmailDelete(email: $email)
  }
`;
